import { css } from "@emotion/css";
import styled from "@emotion/styled";
import type { FC } from "react";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import { isBlogLink } from "lib/Urls";
import reportErrorSentry from "src/lib/reportErrorSentry";

const ionModalStyles = css`
  ion-content {
    &::part(scroll) {
      overflow: hidden;
      padding: 0;
    }
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
`;

const DetailFrame = styled.iframe`
  outline: none;
  border: none;
  width: 100%;
  height: 100%;
  margin: 0;
  padding-bottom: 0 !important;
`;

const IframePopup: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const [query] = useSearchParams();
  const properUrl = decodeURIComponent(query.get("url") ?? "");
  const title = query.get("title") ?? "";
  const isArticle = query.get("popup") === "article";

  const useUrl = useMemo(() => {
    if (!properUrl || properUrl === "undefined") {
      return "";
    }
    try {
      const urlObj = new URL(properUrl);
      if (isBlogLink(properUrl)) {
        // add query param co=1 for content only view
        urlObj.searchParams.append("co", "1");
      }
      return urlObj.toString();
    } catch (e) {
      reportErrorSentry(e, {
        error: new Error("Invalid URL"),
        url: properUrl
      });
      return "";
    }
  }, [properUrl]);

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      popup
      title={title}
      onClose={onClose}
      returnUrl={returnUrl}
      className={ionModalStyles}
      isFullScreen={isArticle}
      noPadding
      disableContentScroll
    >
      {useUrl && <DetailFrame src={useUrl} />}
    </InDialog>
  );
};

export default IframePopup;
